import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'scPolicyStep',
    pure: false
})
export class PolicyStepPipe implements PipeTransform {
    transform(step: string, key: string, subType = '', backendMsg = '', splitPoliza = true): any {
        let final: any = {};
        switch (step) {
            case'COTIZA_1':
                final = {
                    title: 'Cotización',
                    icon: 'assets/images/operations/cotiz-proceso.svg',
                    state: 'Cotización en Proceso',
                    editable: true,
                    viewable: false,
                    color: 'orange'
                };
                break;
            case'COTIZA_2':
                final = {
                    title: 'Cotización',
                    icon: 'assets/images/operations/cotiz-proceso.svg',
                    state: 'Cotización en Proceso',
                    editable: true,
                    viewable: false,
                    color: 'orange'
                };
                break;
            case'COTIZA_3':
                final = {
                    title: 'Cotización',
                    icon: 'assets/images/operations/cotiz-proceso.svg',
                    state: 'Cotización en Proceso',
                    editable: true,
                    viewable: false,
                    color: 'orange'
                };
                break;
            case'COTIZA_4':
                final = {
                    title: 'Cotización',
                    icon: 'assets/images/operations/cotiz-proceso.svg',
                    state: 'Cotización en Proceso',
                    editable: true,
                    viewable: false,
                    color: 'orange'
                };
                break;
            case'COBERT_1':
                final = {
                    title: 'Cobertura',
                    icon: 'assets/images/operations/cotiz-proceso.svg',
                    state: 'Perndiente por Aprobación',
                    editable: true,
                    viewable: false,
                    color: 'orange'
                };
                break;
            case'RESUMEN_1':
                final = {
                    title: 'Resumen',
                    icon: 'assets/images/operations/cotiz-proceso.svg',
                    state: 'Perndiente por Aprobación',
                    editable: true,
                    viewable: false,
                    color: 'orange'
                };
                break;
            case'EMISION_1':
                final = {
                    title: 'Emisión',
                    icon: 'assets/images/operations/emision-proceso.svg',
                    state: 'Emisión en Proceso',
                    editable: true,
                    viewable: false,
                    color: 'orange'
                };
                break;
            case'EMISION_2':
                final = {
                    title: 'Emisión',
                    icon: 'assets/images/operations/emision-proceso.svg',
                    state: 'Emisión en Proceso',
                    editable: true,
                    viewable: false,
                    color: 'orange'
                };
                break;
            case'EMISION_3':
                final = {
                    title: 'Emisión',
                    icon: 'assets/images/operations/emision-proceso.svg',
                    state: 'Emisión en Proceso',
                    editable: true,
                    viewable: false,
                    color: 'orange'
                };
                break;
            case'EMISION_4':
                final = {
                    title: 'Emisión',
                    icon: 'assets/images/operations/emision-proceso.svg',
                    state: 'Emisión en Proceso',
                    editable: true,
                    viewable: false,
                    color: 'orange'
                };
                break;
            case'EMITIENDO':
                final = {
                    title: 'Emisión',
                    icon: 'assets/images/operations/emision-proceso.svg',
                    state: 'Emisión en Proceso',
                    viewable: false,
                    color: 'clear'
                };
                break;
            case'FALLO_EMISION':
                final = {
                    title: 'Emisión',
                    icon: 'assets/images/operations/emision-proceso.svg',
                    state: 'Emisión en Proceso',
                    editable: true,
                    viewable: false,
                    color: 'red'
                };
                break;
            case'VISUALIZA_1':
                final = {
                    title: 'Emisión',
                    icon: subType === 'C' ? 'assets/images/operations/certificado.svg' : 'assets/images/operations/poliza.svg',
                    state: (backendMsg ? (splitPoliza ? backendMsg.replace(' ', '<br/>') : backendMsg) : 'Emisión en Proceso'),
                    editable: false,
                    viewable: true,
                    color: subType === 'C' ? 'blue' : 'green'
                };
                break;
            default:
                final = {
                    title: '----',
                    icon: 'assets/images/operations/emision-proceso.svg',
                    state: 'Emisión en Proceso',
                    editable: false,
                    viewable: false,
                    color: 'orange'
                };
        }
        return final[key];
    }
}
